import { NgClass } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { AbstractControl } from '@angular/forms';

@Component({
    selector: 'pt-validation-hint',
    templateUrl: 'validation-hint.component.html',
    imports: [NgClass],
})
export class ValidationHintComponent implements OnInit {
    @Input() messages: { [key: string]: string };
    @Input() control: AbstractControl;
    message: string;
    classes: string[];

    ngOnInit() {
        let message = this.messages['ValidationInlineMessage'];
        if (!message) {
            return;
        }

        const inlineKeys = Object.keys(this.messages).filter((k) => k.includes('_Inline'));

        inlineKeys.map((k) => {
            message = message.replace(k, () => {
                const klass = k.replace(/_Inline_?\d*/, '').toLowerCase();
                return `<span class="${klass}">${this.messages[k]}</span>`;
            });
        });

        this.message = message;

        this.setValidationClasses();
        this.control.statusChanges.subscribe(() => {
            this.setValidationClasses();
        });
    }

    private setValidationClasses() {
        if (!this.control.errors) {
            this.classes = [];
        } else {
            //password validation check removed before min length
            if (this.control.errors['validPassword'] && this.control.errors['minlength']) {
                delete this.control.errors['validPassword'];
            }
            this.classes = Object.keys(this.control.errors).map((k) => k.toLowerCase());
        }
    }
}
